module.exports = __webpack_public_path__ + "img/telegram-icon.897a1a0f.svg";